import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import CustomCircleLoader from './CustomCircleLoader';
import s from './Loader.css';

const CircleLoader = ({ show = false }) => {
  if (!show) {
    return <div />;
  }

  return (
    <div className={s.textCenter}>
      <CustomCircleLoader size={48} />
    </div>
  );
};

CircleLoader.propTypes = {
  show: PropTypes.bool.isRequired
};

CircleLoader.defaultProps = {
  show: false
};

export default withStyles(s)(CircleLoader);
